import { IOption, IOptions } from '../common/common.types'

export const convertHeightString = (value: string): string => {
  const hp = value.split(' ')
  return hp[0]
}

export const convertWeightString = (value: string): string => {
  return value.replace(/\D/g, '')
}

export const convertZIPString = (value: string): string => {
  return value.substring(0, 5)
}

export const getOption = (id: string, options: IOptions): IOption => {
  return options.filter((option) => String(option.id) === id)[0]
}

enum HeightUnits {
  cm = 'cm',
  in = 'in',
}
export const convertHeightUnitString = (value: string): string => {
  const hp = value.split(' ')
  if (hp.length > 1) {
    switch (hp[1].toLowerCase()) {
      case 'in':
        return HeightUnits.in
      case 'cm':
        return HeightUnits.cm
      default:
        return HeightUnits.in
    }
  } else {
    return HeightUnits.in
  }
}

export const isNewYorkStateLicense = (licenseData: Array<string>): boolean => {
  return licenseData.includes('DAJNY')
}

enum Genders {
  Male = 'M',
  Female = 'F',
  Other = 'U',
}
export const convertGenderString = (value: string): string => {
  switch (value.toLowerCase()) {
    case 'male':
      return Genders.Male
    case 'female':
      return Genders.Female
    default:
      return Genders.Other
  }
}

enum DlStates {
  HI = '1',
  CA = '2',
  AZ = '3',
}
export const convertDlStateString = (value: string): string => {
  switch (value) {
    case 'AZ':
      return DlStates.AZ
    case 'CA':
      return DlStates.CA
    default:
      return DlStates.HI
  }
}

enum Weights {
  Pounds = 'l',
}
export const convertWeightUnitString = (value: string): string => {
  // todo: fix regex for Safari browsers
  // const weightUnit = value.match(/(?<=\().*(?=\))/gm)
  // const weightUnitString = weightUnit ? weightUnit.join('') : ''
  // switch (weightUnitString) {
  //   case 'pounds':
  //     return Weights.Pounds
  //   case 'kilos':
  //     return Weights.Kilos
  //   default:
  //     return weightUnitString
  // }
  return Weights.Pounds
}

enum Countries {
  USA = '1',
  CA = '2',
}
export const convertCountryString = (value: string): string => {
  switch (value) {
    case 'USA':
      return Countries.USA
    case 'CA':
      return Countries.CA
    default:
      return Countries.USA
  }
}

export const convertFirstLetterToUpperCase = (value: string): string => {
  return value[0].toUpperCase() + value.slice(1).toLowerCase()
}

export const removeExtraDecimalPoints = (input: string) => {
  const regex = /^(\d*)((?:\.\d*)+)?$/
  const match = input.toString().match(regex)

  if (match) {
    const integerPart = match[1] || ''
    const decimalPart = match[2] || ''

    // Check if the input has no numbers and only decimal points
    if (integerPart === '' && decimalPart.replace(/\./g, '') === '') {
      return ''
    }

    let numberString = integerPart
    if (decimalPart) {
      numberString = integerPart + '.' + decimalPart.replace(/\./g, '')
    }
    return numberString
  }

  return input
}
